import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { PaymentType } from "@/interfaces/payment-type.interface";
import t2payService from "@/services/t2pay.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaymentType[] | null>;

const useGetPaymentTypes = (): Return => {
  const { data = null, isValidating: isLoading, error } = useSWR<PaymentType[], Error>(
    [SWR_KEYS.getPaymentTypes],
    () => t2payService.getPaymentTypes(),
    { revalidateOnFocus: false, dedupingInterval: 5000 }
  );

  return { data, isLoading, error };
};

export default useGetPaymentTypes;
